var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shape-editor"},[_c('h5',[_vm._v(_vm._s(_vm.$options.name))]),_c('textarea',{attrs:{"value":"shape editor"}}),_c('div',{staticClass:"brute-hide"},[_vm._v(" attribut : "+_vm._s(_vm.attribut)+" "),_c('hr')])])}
var staticRenderFns = []

export { render, staticRenderFns }